// extracted by mini-css-extract-plugin
export default {"section":"NotFound404_section__2XKwA","number_glow":"NotFound404_number_glow__kkHHU"};